import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors';

/**
 * Retries only failures a retry can fix (network, 5xx, 429 after its Retry-After); a 4xx is an
 * answer, not a fault. Exported so a query with its own retry rule (Markets' warming reads) can
 * fall back to this one for every other failure.
 */
export function retryPolicy(count: number, error: unknown): boolean {
  if (!isApiError(error)) return count < 2;
  if (error.kind === 'network' || error.kind === 'server') return count < 2;
  if (error.kind === 'rateLimited') return count < 1;
  return false;
}

export function retryDelayPolicy(attempt: number, error: unknown): number {
  return isApiError(error) && error.retryAfterSeconds ? error.retryAfterSeconds * 1000 : Math.min(1000 * 2 ** attempt, 8000);
}

/** Live views schedule their own refetch at the next bar close (§14.13). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: retryPolicy,
      retryDelay: retryDelayPolicy,
    },
    mutations: { retry: false },
  },
});
